enum MenuType {
  NOTICE = "NOTICE",
  SETTING = "SETTING",
  CUSTOMER = "CUSTOMER",
  MAIL = "MAIL",
  RESERVATION = "RESERVATION",
  PLAN = "PLAN",
}

export default MenuType;
